import { ERequestApiStatus, EWsClientEventType, TAppState } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage } from '../../utils/messageUtils';
import { setSendMessageFailed } from '../sendMessage';

/**
 * Не удалось установить сессию после четырёх попыток
 */
export const registerWsSessionFailed = (): TThunkAction<void> => (dispatch, getState) => {
  const {
    socket: { clientEvents },
    chatWindow: { messagesMap },
  }: TAppState = getState();

  for (const [key, value] of clientEvents.entries()) {
    if (value.status === ERequestApiStatus.Pending) {
      clientEvents.set(key, { ...value, status: ERequestApiStatus.Failed });

      if (value.type === EWsClientEventType.Message) {
        const messageItem = messagesMap.get(key);

        if (messageItem) {
          const {
            message: {
              message: { message: text, userId },
              chatId,
            },
          } = messageItem;

          const message = createOutcomingMessage({ text, chatId, userId });
          dispatch(setSendMessageFailed({ message, messageId: key }));
        }
      }
    }
  }
};
